module.exports = __webpack_public_path__ + "static/img/bindimg.48cbb854.png";